import React, { useRef, useEffect, useState } from 'react';

export default function WebcamMotionLite() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const prevFrame = useRef<ImageData | null>(null);

  const [motion, setMotion] = useState(0);
  const [status, setStatus] = useState('Initializing camera...');

  useEffect(() => {
    const videoElement = videoRef.current; // Capture the current value

    const setupCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoElement) {
          videoElement.srcObject = stream;
          videoElement.onloadedmetadata = () => {
            videoElement.play();
            setStatus('Camera active');
          };
        }
      } catch (err) {
        console.error(err);
        setStatus('Camera access denied');
      }
    };

    setupCamera();

    return () => {
      // Fixed: Use captured videoElement for cleanup
      if (videoElement?.srcObject) {
        const tracks = (videoElement.srcObject as MediaStream).getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, []);

  useEffect(() => {
    const detectMotion = () => {
      if (!videoRef.current || !canvasRef.current) {
        requestAnimationFrame(detectMotion);
        return;
      }

      const ctx = canvasRef.current.getContext('2d', { willReadFrequently: true });
      if (!ctx) return;

      ctx.drawImage(videoRef.current, 0, 0, 320, 240);
      const frame = ctx.getImageData(0, 0, 320, 240);

      let diff = 0;
      if (prevFrame.current) {
        for (let i = 0; i < frame.data.length; i += 4) {
          diff += Math.abs(frame.data[i] - prevFrame.current.data[i]);
        }
      }

      setMotion(diff);
      prevFrame.current = frame;
      requestAnimationFrame(detectMotion);
    };

    detectMotion();
  }, []);

  const isStable = motion < 500000;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', minHeight: '240px', background: '#000', borderRadius: 8, overflow: 'hidden' }}>
      <video ref={videoRef} width="100%" height="100%" style={{ objectFit: 'cover' }} muted />
      <canvas ref={canvasRef} width="320" height="240" style={{ display: 'none' }} />
      
      <div style={{
        position: 'absolute', top: 10, right: 10,
        background: isStable ? '#34de9a' : '#ff4d4f',
        color: 'white', padding: '6px 12px', borderRadius: 12, fontSize: 12, fontWeight: 600
      }}>
        {isStable ? 'Stable' : 'Too much movement'}
      </div>

      {!videoRef.current?.srcObject && (
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: 'white' }}>
          {status}
        </div>
      )}
    </div>
  );
}